import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_33c1ec6d: FaireBrandEntity = {
  token: "b_33c1ec6d",
  type: "brand",
  name: "Mt. Angel Vitamins",
  avatarUrl:
    "https://cdn.faire.com/fastly/91db5e6eae22ef6b8541588918a204d5fd25b15f293aa0ee67143314a9265c39.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/03decfb39f84ea84e22560561ce8dc87719eae827399778985eae61f903faa4f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/91db5e6eae22ef6b8541588918a204d5fd25b15f293aa0ee67143314a9265c39.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/03decfb39f84ea84e22560561ce8dc87719eae827399778985eae61f903faa4f.png",
  location: "Mt. Angel, OR, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 9,
  isInsider: true,
  description:
    "We're a small business located in the heart beat of rural Oregon. For over 50 years, our company has manufactured and distributed only the highest quality dietary supplements and nutraceuticals possible. We've continued to invest in ourselves, our 60+ team members, and our community during that time; creating a brand with integrity, corporate and environmental responsibility, and a commitment to excellence in every bottle.\nMt. Angel Vitamins takes its name from the town where we work and live: Mt. Angel, Oregon. Best known for the Mt. Angel Abbey and the annual Oktoberfest, Mt. Angel is a small town of 3,500 people. Nestled within the beautiful agricultural region of the Willamette Valley, it has been our home for over 40 years.\nWe manufacture all our own products and have for 50 years right here in the USA! We not only source raw materials from the best suppliers, we verify, test, and verify again. Nothing is more important in our industry than trust.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:09.918Z",
    importedBy: "entity-db-cli",
  },
};
